import React, { useState, useEffect } from 'react';
import './CookieConsent.css'; // Import the CSS file for styling

const CookieConsent = ({ onAccept }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasUserConsent = localStorage.getItem('cookieConsent');
    if (!hasUserConsent) setIsVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
    // onAccept();
  };

  return isVisible ? (
    <div className="cookie-consent">
      <p className="cookie-message">
        We use cookies to improve your experience, including Google Analytics and Sentry. By clicking "OK," you consent to the use of cookies.
      </p>
      <button className="cookie-button ok" onClick={handleAccept}>
        OK
      </button>
    </div>
  ) : null;
};

export default CookieConsent;